export default __webpack_public_path__ + "static/media/infoCircle.e5595793.svg";